export enum Actor {
  InnovativeCompany = "entities",
  ResearchGroup = "groups",
  Incubator = "Incubadoras de empresa de base tecnológica",
  ProminentResearcher = "searchers",
  Company = "entities",
  University = "universities",
  Commons = "commons",
  Capacities = "commons_capacities",
}

export interface Entity {
  user_created: any | null; // Ajustar el tipo si tienes más detalles (e.g., string, number, etc.)
  user_updated: any | null;
  updated_at: string; // ISO string para fechas y horas
  created_at: string;
  id_entity: any | null;
  stateRaw: string;
  cityRaw: string;
  contact_email: string;
  contact_name: string;
  recognized_min: string; // Cambiar a número si se espera que sea un valor numérico
  update_date: string; // ISO string
  source: string;
  current_date: string;
  issue_date: string; // ISO string
  city: any | null;
  nit: string;
  features: any | null;
  url: string;
  description: string;
  social_reason: string;
  state: any | null;
  phone: string;
  external_code: string;
  economic_sector: any | null;
  actor_type: number;
  id: string;
  ciiu: number[]; // Arreglo de números
  searchers: number[]; // Arreglo de números
  products: any[]; // Ajustar el tipo de los productos si tienes más detalles
}

export interface DataItem {
  href: string;
  title: string;
  avatar: string;
  contact_email: string;
  description: string;
  content: string;
}

export interface IconTextProps {
  icon: React.FC;
  text: string;
}

export interface Result<T> {
  loading?: boolean;
  values: T[];
  pagination?: Pagination;
}

export enum Capacity {
  Products = "products",
  Projects = "projects",
  CommonsCapacity = "commons_capacities",
}

export interface CommonCapacities {
  id: string;
  name: string;
  typology: string;
  group: string;
  description: string;
  type: string;
  recognized_min: string;
  collection_name?: string;
  contact_name: string;
  contact_email: string;
  recommended?: boolean;
}

export interface Pagination {
  page?: number;
  limit?: number;
  total?: number;
}

export enum SortMode {
  ASC = "",
  DES = "-",
}

interface Sort {
  field: string;
  mode: SortMode;
}

export interface Query {
  sort?: Sort[];
  search?: string;
  filter: any;
  meta?: string;
  paginate?: Pagination;
}

export interface IProtectedRouteProps {
  user: any;
  redirectPath?: string;
}

export enum RecordStatus {
  Active = "published",
  Draft = "draft",
}

export interface EntityRaw {
  userCreated: string | null;
  userUpdated: string | null;
  updatedAt: string;
  createdAt: string;
  idEntity: string | null;
  stateRaw: string;
  cityRaw: string;
  contactEmail: string;
  contactName: string;
  recognizedMin: number;
  updateDate: string;
  source: string;
  currentDate: string;
  issueDate: string;
  city: string | null;
  nit: string;
  features: any | null;
  url: string;
  description: string;
  socialReason: string;
  state: string | null;
  phone: string;
  externalCode: string;
  economicSector: any | null;
  actorType: number;
  id: string;
  ciiu: number[];
  searchers: any[];
  products: any[];
}

export interface Contact {
  name?: string;
  email?: string;
  organization_name?: string;
  type?: any;
  actor?: any;
  city?: string;
  cityRaw?: string;
}

export interface CommonEntityRaw {
  id: string;
  name: string;
  description?: string;
  type: string;
  city: string;
  state: string;
  recognized_min: string;
  collection_name?: string;
  contact_name?: string;
  contact_email?: string;
}

export interface CommonEntity {
  id: string;
  name: string;
  description?: string;
  type: any;
  city: string;
  cityRaw?: string;
  state: string;
  recognized_min: string;
  collection_name?: string;
  contact_name?: string;
  contact_email?: string;
  recommended?: boolean;
}

export interface User {
  email: string;
  password?: string;
  first_name: string;
  role: string;
  last_name: string;
  canCreateAnnouncement?: boolean;
  canCreateEvents?: boolean;
  city: string;
  state: string;
  phone: string;
  id?: string;
}

export enum RequestType {
  Sended = "sended",
  Received = "received",
}

export enum RequestStatus {
  Rejected = "rejected",
  Accepted = "accepted",
  Pending = "pending",
  Cancelled = "cancelled",
}

export enum RequestStatusMapping {
  rejected = "Rechazada",
  accepted = "Aceptada",
  pending = "Pendiente",
  cancelled = "Cancelada",
}

export enum XHRMessages {
  Rejected = "No tienes acceso a este recurso.",
  TokenExpired = "Tu sesión a finalizado.",
  BadRequest = "Ocurrió un error al enviar los datos.",
  NoFound = "Recurso no encontrado",
  InternalErrror = "Ocurrió un error inesperado.",
}
export interface Product {
  id: string;
  key?: string;
  name: string;
  group: string;
  type: string;
  university: string;
  external_code?: string;
  contact_name: string;
  contact_email: string;
  created_at?: string;
  updated_at?: string;
}

export interface ProductRaw {
  id?: string;
  contact_email?: string;
  universities: any[];
  external_code?: string;
  contact_name?: string;
  recognized_min?: string;
  persona?: any;
  id_persona_pd?: string;
  groups: any[];
  searchers: any[];
  id_producto_pd?: string;
  nme_producto_pd: string;
  fcreacion_pd?: string;
  nme_tipologia_pd: string;
  cod_grupo_gr?: any;
  capacity_type?: number;
}

export interface CommonsCapacitiesRaw {
  nombre: string;
  descripcion: string;
  descripcion_detallada: string;
  problemas_que_soluciona: string;
  beneficios_que_genera: string;
  caracteristicas_de_productos_yo_servicios_que_genera: string;
  grado_de_madurez_de_la_solucion_capacidad: string;
  beneficiario: string;
  external_code: string;
  identidad: string;
  capacity_type: number;
  presupuesto: string;
  gran_area_de_conocimiento: number;
  especialidad_de_conocimiento: number;
  area_de_conocimiento: number;
  id?: string;
}
export interface CommonsCapacities {
  nombre: string;
  descripcion: string;
  beneficiario: string;
  external_code: string;
  identidad: string;
  beneficios_que_genera: string;
  caracteristicas_de_productos_yo_servicios_que_genera: string;
  grado_de_madurez_de_la_solucion_capacidad: string;
  descripcion_detallada: string;
  problemas_que_soluciona: string;
  capacity_type: number;
  presupuesto: string;
  gran_area_de_conocimiento: number;
  especialidad_de_conocimiento: number;
  area_de_conocimiento: number;
  id?: string;
}
export interface Searcher {
  id?: string;
  phone: string;
  description: string | null;
  contact_email: string;
  contact_name: string;
  city: string | null;
  features: string;
  recognized_min: string;
  update_date: string;
  source: string;
  issue_date: string;
  current_date: string;
  inst_filia: string;
  id_institucion: string | null;
  nme_municipio_res_pr?: string;
  nme_clasificacion_pr?: string;
  nme_niv_form_pr: string;
  nme_gran_area_pr: string;
  nme_esp_area_pr: string;
  nombre: string;
  id_persona_pr: string;
  nme_area_pr: string;
  actor_type: number;
  enlace_cvlac?: string;
  created_at: string;
  updated_at: string;
}

export interface Role {
  id?: string | undefined;
  name: string;
}

export interface EventAdapter {
  id: string;
  date: string;
  startTime: string;
  endTime: string;
  title: string;
  organizer: string;
  location?: string;
  description?: string;
  image?: string;
}

export interface Project {
  user_created: string;
  user_updated: string;
  created_at: string;
  updated_at: string;
  tipo_proyecto: string;
  tiempo_de_ejecucion_estimado: string;
  presupuesto_estimado: string;
  aliados_del_proyecto: string;
  descripcion_detallada: string;
  descripcion: string;
  titulo_proyecto: string;
  city: string;
  id?: string;
  capacity_type: number;
  gran_area_de_conocimiento: number;
  especialidad_de_conocimiento: number;
  area_de_conocimiento: number;
  estado_proyecto: number;
  products: number[];
}
export interface EventstRaw {
  user_updated: string | null;
  user_created: string;
  created_at: string;
  updated_at: string | null;
  visibility_end_date: string;
  visibility_start_date: string;
  description: string;
  url: string;
  banner: string;
  type: string;
  location: string;
  organizer_fullname: string;
  name: string;
  status: string;
  id?: string;
}
export interface Events {
  user_updated: string | null;
  user_created: string;
  created_at: string;
  updated_at: string | null;
  visibility_end_date: string;
  visibility_start_date: string;
  description: string;
  url: string;
  banner: string;
  type: string;
  location: string;
  organizer_fullname: string;
  name: string;
  status: string;
  id?: string;
}

export interface AnnouncementRaw {
  user_updated: string | null;
  user_created: string;
  created_at: string;
  updated_at: string | null;
  visibility_end_date: string;
  visibility_start_date: string;
  tipo_organizacion: string;
  tecnologias: string;
  nombre: string;
  institucion?: string;
  responsable?: string;
  requisitos_no_deseables: string;
  descripcion_detallada: string;
  solucion: string;
  expectativas_solucion: string;
  requisitos_obligatorios: string;
  descripcion_breve: string;
  requisitos_deseables: string;
  presupuesto: number;
  id?: string;
  url?: string;
  sub_areas: number[];
  areas: number[];
  image: string;
  status: string;
  document: string;
}

export interface Announcement {
  user_updated: string | null;
  user_created: string;
  created_at: string;
  updated_at: string | null;
  visibility_end_date: string;
  visibility_start_date: string;
  tipo_organizacion: string;
  tecnologias: string;
  nombre: string;
  institucion?: string;
  responsable?: string;
  requisitos_no_deseables: string;
  descripcion_detallada: string;
  solucion: string;
  expectativas_solucion: string;
  requisitos_obligatorios: string;
  descripcion_breve: string;
  requisitos_deseables: string;
  presupuesto: number;
  id?: string;
  sub_areas?: string;
  areas?: string;
  image: string;
  url?: string;
  status: string;
  document: string;
}

export interface ProjectRaw {
  user_created: string;
  user_updated: string;
  created_at: string;
  updated_at: string;
  tipo_proyecto: string;
  tiempo_de_ejecucion_estimado: string;
  presupuesto_estimado: string;
  aliados_del_proyecto: string;
  descripcion_detallada: string;
  descripcion: string;
  titulo_proyecto: string;
  city: string;
  id?: string;
  capacity_type: number;
  gran_area_de_conocimiento: number;
  especialidad_de_conocimiento: number;
  area_de_conocimiento: number;
  estado_proyecto: number;
  products: number[];
}

export interface SearcherRaw {
  phone: string;
  contact_email: string;
  contact_name: string;
  city: string | null;
  description: string | null;
  recognized_min: number;
  update_date: string;
  source: string;
  features: string;
  issue_date: string;
  current_date: string;
  inst_filia: string;
  enlace_cvlac: string;
  id_institucion: string | null;
  nme_municipio_res_pr?: string;
  nme_clasificacion_pr?: string;
  nme_niv_form_pr: string;
  nme_gran_area_pr?: string;
  nme_area_pr?: string;
  nme_esp_area_pr?: string;
  nombre: string;
  id_persona_pr: string;
  actor_type: number;
  universities: [];
  products: [];
  entity: any[];
  id?: string;
}

export interface Group {
  id?: string;
  contact_email?: string;
  contact_name?: string;
  nme_clasificacion_gr?: string;
  fcreacion_pd: string;
  created_at?: string;
  updated_at?: string;
  nme_municipio_gr?: string;
  nme_gran_area_gr?: string;
  nme_area_gr?: string;
  nme_area_esp_gr?: string;
  cod_grupo_gr?: string;
  nme_grupo_gr?: string;
  description?: string;
  actor_type: number;
  recognized_min?: string;
  features?: string;
  city?: string;
  url?: string;
  codigo_institucion?: string[];
  universities?: string[];
}

export interface University {
  contact_email: string | null;
  contact_name: string | null;
  city: string | null;
  phone: string;
  update_date: string | null;
  source: string | null;
  current_date: string | null;
  issue_date: string | null;
  features: string | null;
  description: string | null;
  url: string;
  municipality: string;
  state: string;
  institution_name: string;
  institution_code: string;
  recognized_min: string | null;
  is_accredited: string;
  actor_type: number;
  id?: number;
  searchers: any[];
  universities_searchers?: any[];
  groups?: any[];
  universities_entities: any[];
  created_at?: string;
  updated_at?: string;
}

export interface ActorTypeRaw {
  user_updated: string;
  user_created: string;
  date_created: string;
  date_updated: string;
  collection_name: string;
  actor: string;
  status: string;
  sort: string | null; // Assuming sort can be null
  id: number;
}
export interface ActorType {
  user_updated: string;
  user_created: string;
  date_created: string;
  date_updated: string;
  collection_name: string;
  actor: string;
  status: string;
  sort: string | null; // Assuming sort can be null
  id: number;
}

export interface AnalyticsType {
  rejects: number;
  accepted: number;
  actor: string;
}

export interface routerData {
  id: string;
  name: string;
  type: string;
}

export interface UniversityRaw {
  contact_email: string | null;
  contact_name: string | null;
  phone: string;
  city: string | null;
  update_date: string;
  source: string | null;
  current_date: string;
  issue_date: string;
  features: string | null;
  description: string | null;
  url: string;
  municipality: string;
  state: string;
  institution_name: string;
  institution_code: string;
  recognized_min: number | null;
  is_accredited: number;
  actor_type: number;
  id?: string;
  searchers: any[];
  universities_searchers?: any[]; // Tipo de datos para universities_searchers
  groups?: any[]; // Tipo de datos para universities_searchers
  universities_entities?: any[]; // Tipo de datos para universities_entities
  created_at?: string;
  updated_at?: string;
}

export interface GroupRaw {
  id?: string;
  contact_email?: string;
  contact_name?: string;
  nme_clasificacion_gr?: string;
  fcreacion_pd: string;
  created_at?: string;
  updated_at?: string;
  source: string;
  update_date?: string;
  current_date: string;
  issue_date?: string;
  nme_municipio_gr?: string;
  nme_gran_area_gr?: string;
  nme_area_gr?: string;
  nme_area_esp_gr?: string;
  cod_grupo_gr?: string;
  nme_grupo_gr?: string;
  description?: string;
  actor_type: number;
  recognized_min?: string;
  features?: string;
  city?: string;
  url?: string;
  codigo_institucion?: string[];
  universities?: string[];
}

export interface CommonsRaw {
  id?: string;
  url: string;
  ciudad: string;
  descripcion: string;
  services: string;
  sector: string;
  nombre: string;
  external_code: string;
  phone: string;
  contact_email: string;
  contact_name: string;
  city: string;
  state: string;
  update_date: string;
  source: string;
  features: string;
  current_date: string;
  issue_date: string;
  recognized_min: string;
  dependencie_value: string;
  actor_type: number;
  dependencie_type: number;
  especialidad_de_conocimiento: number;
  gran_area_de_conocimiento: number;
  area_de_conocimiento: number; // Agregamos este campo
}

export interface Commons {
  url: string;
  ciudad: string;
  descripcion: string;
  nombre: string;
  external_code: string;
  phone: string;
  contact_email: string;
  contact_name: string;
  city: string;
  state: string;
  update_date: string;
  source: string;
  current_date: string;
  issue_date: string;
  recognized_min: string;
  dependencie_value: string;
  created_at?: string;
  updated_at?: string;
  id?: number;
  features: string;
  actor_type: number;
  dependencie_type: number;
  especialidad_de_conocimiento: number;
  gran_area_de_conocimiento: number;
  area_de_conocimiento: number; // Agregamos este campo
}

export interface CapacitiesTypesRaw {
  capacities: string;
  collection_name: string;
  id: string;
}

export interface CapacitiesRaw {
  contact_name: string;
  contact_email: string;
  nombre: string;
  descripcion: string;
  beneficiario: string;
  external_id: string;
  identidad: string;
  beneficios_que_genera: string;
  caracteristicas_de_productos_yo_servicios_que_genera: string;
  grado_de_madurez_de_la_solucion_capacidad: string;
  descripcion_detallada: string;
  problemas_que_soluciona: string;
  capacity_type: number;
  presupuesto: string;
  gran_area_de_conocimiento: number;
  especialidad_de_conocimiento: number;
  area_de_conocimiento: number;
  id: string;
}

export interface CapacitiesType {
  contact_email: string;
  contact_name: string;
  collection_name: string;
  type: string;
  name: string;
  recognized_min: number;
  typology: string;
  id: number;
}

export interface RequestConnection {
  id: string;
  from?: User;
  content: string;
  owner: string;
  type?: Capacity;
  status?: RequestStatus;
  to?: User;
}

export enum PageSetting {
  page = 1,
  limit = 15,
}

export interface Props {
  user?: {
    email: string;
    avatar: string;
    role: string;
  };
}

export enum RoleType {
  Root = "Administrator",
  Admin = "Admin",
  Public = "Public",
  InstitutionalAdmin = "InstitutionalAdmin",
  Financier = "Financier",
  Coordinator = "Coordinator",
  KnowledgeProvider = "KnowledgeProvider",
  KnowledgeConsumer = "KnowledgeConsumer",
}

export enum RoleTypeMap {
  Administrator = "Administrador",
  Admin = "Administrador",
  InstitutionalAdmin = "Administrador institucional",
  Financier = "Financiero",
  Coordinator = "Coordinador",
  KnowledgeProvider = "Proveedor de CTI",
  KnowledgeConsumer = "Consumidor CTI",
  Public = "Public",
}

export interface PropsCapacitiesList {
  list: CommonCapacities[];
  loading?: boolean;
}

export interface PropsEntities {
  data: any;
}

export interface ILoginViewProps {}

export enum TokenType {
  info = "info",
  success = "Success",
  error = "error",
  warning = "warning",
}

export enum AuthMessages {
  Title = "UNAB",
  AccountCreated = "Cuenta creada correctamente",
  AccountCreatedError = "El correo ya se encuentra en uso.",
  LoginSuccess = "Logueado correctamente",
}

export enum ProfileMessages {
  Title = "UNAB",
  ProfileUpdateSuccessMessage = "Información actualizada correctamente.",
  ProfileUpdateErrorMessage = "Ocurrio un error al actualizar. Intente mas tarde",
  ProfileConfirmMessage = "¿Confirma que desea actualizar estos datos?",
}

export enum ProductsMessages {
  Title = "UNAB",
  ProductsUpdateSuccessMessage = "Información actualizada correctamente.",
  ProductCreated = "Producto agregado correctamente",
  ProductsDeleteSuccessMessage = "Registro eliminado correctamente.",
  ProductsUpdateErrorMessage = "Ocurrio un error al actualizar. Intente mas tarde",
  ProductsConfirmDeleteMessage = "¿Confirma que desea borrar este registro?",
}

export enum SearcherMessages {
  Title = "UNAB",
  SearcherUpdateSuccessMessage = "Información actualizada correctamente.",
  SearcherCreated = "Investigador agregado correctamente",
  SearchersDeleteSuccessMessage = "Registro eliminado correctamente.",
  SearchersUpdateErrorMessage = "Ocurrio un error al actualizar. Intente mas tarde",
  SearchersConfirmDeleteMessage = "¿Confirma que desea borrar este registro?",
}

export enum CommonsCapacitiesMessages {
  Title = "UNAB",
  CommonsCapacitiesrUpdateSuccessMessage = "Información actualizada correctamente.",
  CommonsCapacitiesCreated = "Capacidad agregado correctamente",
  CommonsCapacitiesDeleteSuccessMessage = "Registro eliminado correctamente.",
  CommonsCapacitiesUpdateErrorMessage = "Ocurrio un error al actualizar. Intente mas tarde",
  CommonsCapacitiesConfirmDeleteMessage = "¿Confirma que desea borrar este registro?",
}

export enum AnnouncementMessages {
  Title = "UNAB",
  AnnouncementUpdateSuccessMessage = "Información actualizada correctamente.",
  AnnouncementCreated = "Convocatoria agregado correctamente",
  AnnouncementsDeleteSuccessMessage = "Registro eliminado correctamente.",
  AnnouncementsUpdateErrorMessage = "Ocurrio un error al actualizar. Intente mas tarde",
  AnnouncementsConfirmDeleteMessage = "¿Confirma que desea borrar este registro?",
}

export enum EventtMessages {
  Title = "UNAB",
  EventUpdateSuccessMessage = "Información actualizada correctamente.",
  EventCreated = "Evento agregado correctamente",
  EventPublished = "¿Confirma que desea publicar este evento?",
  EventsDeleteSuccessMessage = "Registro eliminado correctamente.",
  EventsUpdateErrorMessage = "Ocurrio un error al actualizar. Intente mas tarde",
  EventsConfirmDeleteMessage = "¿Confirma que desea borrar este registro?",
}

export enum UniversityMessages {
  Title = "UNAB",
  UniversityUpdateSuccessMessage = "Información actualizada correctamente.",
  UniversityCreated = "Universidad agregada correctamente",
  UniversitiesDeleteSuccessMessage = "Registro eliminado correctamente.",
  UniversitiesUpdateErrorMessage = "Ocurrio un error al actualizar. Intente mas tarde",
  UniversitiesConfirmDeleteMessage = "¿Confirma que desea borrar este registro?",
}

export enum UsersMessages {
  Title = "UNAB",
  UserUpdateSuccessMessage = "Información actualizada correctamente.",
  UserCreated = "Usuario agregado correctamente",
  userDeleteSuccessMessage = "Registro eliminado correctamente.",
  userUpdateErrorMessage = "Ocurrio un error al actualizar. Intente mas tarde",
  userConfirmDeleteMessage = "¿Confirma que desea borrar este registro?",
}

export enum CommonsMessages {
  Title = "UNAB",
  CommonsUpdateSuccessMessage = "Información actualizada correctamente.",
  CommonsCreated = "Entidad agregada correctamente",
  CommonsDeleteSuccessMessage = "Registro eliminado correctamente.",
  CommonsUpdateErrorMessage = "Ocurrio un error al actualizar. Intente mas tarde",
  CommonsConfirmDeleteMessage = "¿Confirma que desea borrar este registro?",
}

export enum ImportMessages {
  Title = "UNAB",
  ImportConfirmMessage = "¿Confirma que desea importar este catalogo?",
  ImportSuccessMessage = "Tarea de importación iniciada. Se enviara un email cuando finalize.",
}

export enum GroupsMessages {
  Title = "UNAB",
  GroupsUpdateSuccessMessage = "Información actualizada correctamente.",
  GroupCreated = "Grupo agregado correctamente",
  GroupsDeleteSuccessMessage = "Registro eliminado correctamente.",
  GroupsUpdateErrorMessage = "Ocurrio un error al actualizar. Intente mas tarde",
  GroupsConfirmDeleteMessage = "¿Confirma que desea borrar este registro?",
}

export enum ProjectsMessages {
  Title = "UNAB",
  ProjectsUpdateSuccessMessage = "Información actualizada correctamente.",
  ProjectCreated = "Proyecto agregado correctamente",
  ProjectsDeleteSuccessMessage = "Registro eliminado correctamente.",
  ProjectsUpdateErrorMessage = "Ocurrio un error al actualizar. Intente mas tarde",
  ProjectsConfirmDeleteMessage = "¿Confirma que desea borrar este registro?",
}

export enum EntitiesMessages {
  Title = "UNAB",
  EntitiesCreated = "Entidad agregada correctamente",
  EntitiesDeleteSuccessMessage = "Registro eliminado correctamente.",
  EntitiesConfirmDeleteMessage = "¿Confirma que desea borrar este registro?",
  EntitiesUpdateSuccessMessage = "Información actualizada correctamente.",
  EntitiesUpdateErrorMessage = "Ocurrio un error al actualizar. Intente mas tarde",
  EntitiesConfirmMessage = "¿Confirma que desea actualizar estos datos?",
}

export interface Signup {
  id: string;
  username: string;
  password: string;
  email: string;
  first_name?: string;
  last_name?: string;
  phone?: string;
  avatar?: string | any;
  role?: Role;
  location?: string;
}

export interface Profile {
  id: string;
  username: string;
  password: string;
  email: string;
  first_name?: string;
  last_name?: string;
  phone?: string;
  avatar?: string | any;
  role?: Role;
  location?: string;
}

export interface NotificationPreferences {
  email: boolean;
  pushNotifications: boolean;
}

export interface PrivacySettings {
  publicProfile: boolean;
  hideEmail: boolean;
  hideDateOfBirth: boolean;
}

export interface ThemeSettings {
  themeName: string;
  fontPreferences: string;
  colorScheme: string;
}
